import React from 'react'

export const RegistrationConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/registration',
            component: React.lazy(() => import('./Registration')),
            applicationPath: 'Registration'
        },
        {
            path: '/registration-social',
            component: React.lazy(() => import('./RegistrationSocial')),
            applicationPath: 'RegistrationSocial'
        }
    ]
}

